import {ProgressBar} from 'platform/components';
import {Box, Center} from 'platform/foundation';

import {CSSProperties} from 'react';

import {isNil} from 'ramda';

interface VehicleAlbumVideoPlaceholderProps {
  progress?: number;
  ratio?: CSSProperties['aspectRatio'];
}

// Grid tile shown while a video is being chunk-uploaded / processed by the backend. Indeterminate
// until the first progress value arrives.
export function VehicleAlbumVideoPlaceholder(props: VehicleAlbumVideoPlaceholderProps) {
  return (
    <Box
      width="100%"
      height="100%"
      ratio={props.ratio}
      padding={2}
      border="1px dashed"
      borderColor="palettes.neutral.80.100"
      borderRadius="xSmall"
    >
      <Center height="100%">
        <ProgressBar
          percentage={isNil(props.progress) ? undefined : props.progress}
          indeterminate={isNil(props.progress) || props.progress === 0}
          small
        />
      </Center>
    </Box>
  );
}
